import { render, staticRenderFns } from "./language-dropdown.vue?vue&type=template&id=353b316e&scoped=true&lang=pug&"
import script from "./language-dropdown.vue?vue&type=script&lang=js&"
export * from "./language-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./language-dropdown.vue?vue&type=style&index=0&id=353b316e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b316e",
  null
  
)

component.options.__file = "language-dropdown.vue"
export default component.exports